import { render, staticRenderFns } from "./TextElement.vue?vue&type=template&id=5d307e8c&"
import script from "./TextElement.vue?vue&type=script&lang=js&"
export * from "./TextElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports